import httpClient from '../http'

export default {
  index(batchType, params) {
    return httpClient.get(`/api/batch/${batchType}`, { params })
  }
}
